import type { QuickTipType } from '../../../components/shared/QuickTip/quickTip.types';

export type ImageType =
  | 'ndvi'
  | 'ndvig'
  | 'savi'
  | 'rgb'
  | 'evi'
  | 'ndwi'
  | 'arvi'
  | 'nir'
  | 'rvi'
  | 'raw'
  | 'vari'
  | 'shadow_corrected_drymatter'
  | 'ndvi_variability'
  | 'ndmi'
  | 'lci'
  | 'ndre';

export interface AlgorithmIndex {
  displayName: string;
  description: string;
  value: ImageType;
  exprs: string;
  default: boolean;
  histogramSupported: boolean;
  contrastSupported: boolean;
  prescriptionsSupported: boolean;
  quickTipGuide?: QuickTipType;
  premium?: boolean;
  hasAccess?: boolean;
}

export enum RasterType {
  SMS = 'falsecolor',
  Multicolor = 'multicolor',
  SMS_3 = 'falsecolor_alt_3',
  SMS_4 = 'falsecolor_alt_4',
  SMS_5 = 'falsecolor_alt_5',
  SMS_6 = 'falsecolor_alt_6',
  SMS_8 = 'falsecolor_alt_8',
  SMS_10 = 'falsecolor_alt_10',
  SMS_11 = 'falsecolor_alt_11',
  RAW = 'raw',
  BW = 'bw',
  TRUE_COLOR = 'truecolor',
  HIGHCONTRAST = 'highcontrast',
}

export const CWO_PALETTE_INDEX = {
  SMS: 10,
  Multicolor: 9,
  ContrastView: 6,
  'SMS 3': 11,
  'SMS 4': 12,
  'SMS 5': 13,
  'SMS 6': 14,
  'SMS 8': 15,
  'SMS 10': 16,
};

export type CarbonLayerValue =
  | 'Environment-Soil-Carbon-Actual-Percent-OM-Static-AR-Aapresid-v2'
  | 'Environment-Soil-Carbon-Actual-Tonne-Static-AR-Aapresid-v2'
  | 'Environment-Soil-Carbon-Potential-Percent-OM-Static-AR-Aapresid-v2'
  | 'Environment-Soil-Carbon-Potential-Tonne-Static-AR-Aapresid-v2'
  | 'Environment-Soil-Carbon-Reachable-Percent-OM-Static-AR-Aapresid-v2'
  | 'Environment-Soil-Carbon-Reachable-Tonne-Static-AR-Aapresid-v2';

export type CarbonLayerOption = { value: CarbonLayerValue; type: string };
